@if (this.displayed) {
	<div style="padding-top: 16px">
		<google-map
			#deviceGoogleMap
			min-height="800px"
			height="70vh"
			width="100%"
			[options]="mapOptions"
			[center]="mapCenter"
		>
			<map-marker-clusterer
				#markerClusterer
				(clusterClick)="openClusterMarkerInfo($event)"
				data-automation-id="map-marker-clusterer"
			>
				@for (markerInfo of markersInfo; track markerInfo.deviceSn) {
					<map-marker
						#markerElem="mapMarker"
						[position]="markerInfo.marker.position!"
						[label]="markerInfo.marker.label!"
						[title]="markerInfo.marker.title!"
						[options]="{ icon: markerInfo.marker.icon }"
						(mapClick)="openInfo(markerElem)"
						data-automation-id="map-marker"
					>
					</map-marker>
				}
			</map-marker-clusterer>
			<map-info-window #mapInfoWindow>
				<div [innerHTML]="infoContent"></div>
			</map-info-window>
		</google-map>
	</div>
}
